import CollapsibleIcon from './component.jsx'
export default CollapsibleIcon
